import { render } from "./ServiceNotifications.vue?vue&type=template&id=7b3c8f85"
import script from "./ServiceNotifications.vue?vue&type=script&lang=js"
export * from "./ServiceNotifications.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__